module.exports = __webpack_public_path__ + "static/media/image3.138e0a31.png";